    export default class DurationAction {
    static START_WEEK_REQUEST = 'START_WEEK_REQUEST';
    static START_WEEK_SUCCESS = 'START_WEEK_SUCCESS';
    static START_WEEK_FAILED = 'START_WEEK_FAILED';

    static startWeek_Request() {
        return {
            type: this.START_WEEK_REQUEST
        }
    }

    static startWeek_Success (data) {
        return {
            type: this.START_WEEK_SUCCESS,
            data
        }
    }

    static startWeek_Failed (error) {
        return {
            type: this.START_WEEK_FAILED,
            error
        }
    }
    
        // end week

    static END_WEEK_REQUEST = 'END_WEEK_REQUEST';
    static END_WEEK_SUCCESS = 'END_WEEK_SUCCESS';
    static END_WEEK_FAILED = 'END_WEEK_FAILED';

    static endWeek_Request() {
        return {
            type: this.END_WEEK_REQUEST
        }
    }

    static endWeek_Success (data) {
        return {
            type: this.END_WEEK_SUCCESS,
            data
        }
    }

    static endWeek_Failed (error) {
        return {
            type: this.END_WEEK_FAILED,
            error
        }
    }

    // ELEMENT CHANNEL

    static ELEMENT_REQUEST = 'ELEMENT_REQUEST';
    static ELEMENT_SUCCESS = 'ELEMENT_SUCCESS';
    static ELEMENT_FAILED = 'ELEMENT_FAILED';

    static element_Request() {
        return {
            type: this.ELEMENT_REQUEST
        }
    }

    static element_Success (data) {
        return {
            type: this.ELEMENT_SUCCESS,
            data
        }
    }

    static element_Failed (error) {
        return {
            type: this.ELEMENT_FAILED,
            error
        }
    }

     // SUB ELEMENT CHANNEL

     static SUB_ELEMENT_REQUEST = 'SUB_ELEMENT_REQUEST';
     static SUB_ELEMENT_SUCCESS = 'SUB_ELEMENT_SUCCESS';
     static SUB_ELEMENT_FAILED = 'SUB_ELEMENT_FAILED';
 
     static subElement_Request() {
         return {
             type: this.SUB_ELEMENT_REQUEST
         }
     }
 
     static subElement_Success (data) {
         return {
             type: this.SUB_ELEMENT_SUCCESS,
             data
         }
     }
 
     static subElement_Failed (error) {
         return {
             type: this.SUB_ELEMENT_FAILED,
             error
         }
     }
     
}